import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';

import * as Types from '../../../../../../../../generated/graphql/types';

const defaultOptions = {} as const;
export type AuthChangePasswordUserMutationMutationVariables = Types.Exact<{
  input: Types.UserChangePasswordInput;
}>;

export type AuthChangePasswordUserMutationMutation = {
  __typename?: 'Mutation';
  security: {
    __typename?: 'SecurityMutation';
    change_password_user:
      | {
          __typename?: 'ChangePasswordUserChangedPasswordPayload';
          user_id: string;
        }
      | { __typename?: 'InternalServerMutationError'; errors: Array<string> }
      | { __typename?: 'SecurityMutationError'; errors: Array<string> };
  };
};

export const AuthChangePasswordUserMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AuthChangePasswordUserMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserChangePasswordInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'security' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'change_password_user' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'input' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'input' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'SecurityMutationError',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'errors' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'InternalServerMutationError',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'errors' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'ChangePasswordUserChangedPasswordPayload',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user_id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AuthChangePasswordUserMutationMutationFn = Apollo.MutationFunction<
  AuthChangePasswordUserMutationMutation,
  AuthChangePasswordUserMutationMutationVariables
>;

/**
 * __useAuthChangePasswordUserMutationMutation__
 *
 * To run a mutation, you first call `useAuthChangePasswordUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthChangePasswordUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authChangePasswordUserMutationMutation, { data, loading, error }] = useAuthChangePasswordUserMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthChangePasswordUserMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthChangePasswordUserMutationMutation,
    AuthChangePasswordUserMutationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AuthChangePasswordUserMutationMutation,
    AuthChangePasswordUserMutationMutationVariables
  >(AuthChangePasswordUserMutationDocument, options);
}
export type AuthChangePasswordUserMutationMutationHookResult = ReturnType<
  typeof useAuthChangePasswordUserMutationMutation
>;
export type AuthChangePasswordUserMutationMutationResult =
  Apollo.MutationResult<AuthChangePasswordUserMutationMutation>;
export type AuthChangePasswordUserMutationMutationOptions =
  Apollo.BaseMutationOptions<
    AuthChangePasswordUserMutationMutation,
    AuthChangePasswordUserMutationMutationVariables
  >;
